export default __webpack_public_path__ + "static/media/753800e3048c62b5bce0f771d728c6af1600817680081.1fbefda2.webp";